import request from '@/utils/http'

// 获取角色列表:
function getRoleList (params: any) {
  return request({
    url: `role/list/${params.pageNo}/${params.pageSize}`,
    method: 'get'
  })
}

// 获取角色的权限列表:
function getRoleAuthoritys (params: any) {
  return request({
    url: `role/roleAuthoritys/${params.roleId}`,
    method: 'get'
  })
}

// 创建或修改角色:
function saveOrUpdateOfRole (params: any) {
  return request({
    url: `role/saveOrUpdate`,
    method: 'post',
    data: { ...params }
  })
}

// 保存或修改角色的权限列表:
function saveRoleAuthoritysOfRole (params: any) {
  return request({
    url: `role/saveRoleAuthoritys`,
    method: 'post',
    data: params
  })
}

// 删除角色:
function deleteRole (params: any) {
  return request({
    url: `role/${params.roleId}`,
    method: 'delete'
  })
}

// 查看全部:
function getAllAuthority () {
  return request({
    url: `authority/listTier`,
    method: 'get'
  })
}

export default {
  getRoleList,
  getRoleAuthoritys,
  saveOrUpdateOfRole,
  saveRoleAuthoritysOfRole,
  deleteRole,
  getAllAuthority
}
